module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-overlay",
    style: (_vm.overlayStyle)
  }, [_c('div', {
    staticClass: "trial-lockout-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "past-due-lockout-title"
    }
  }, [_c('div', {
    staticClass: "trial-lockout-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-lockout-title",
    attrs: {
      "id": "past-due-lockout-title"
    }
  }, [_vm._v(_vm._s(_vm.copy.title))]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-sub",
    domProps: {
      "innerHTML": _vm._s(_vm.copy.messageHtml)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "trial-lockout-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goUpdatePayment
    }
  }, [_vm._v("\n      Update payment method →\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-foot"
  }, [_c('a', {
    attrs: {
      "href": "mailto:support@sentrykit.com?subject=SentryKit%20payment%20failed"
    }
  }, [_vm._v("Contact support")]), _vm._v("\n      ·\n      "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Log out")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88e04e18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/PastDueLockoutOverlay.vue
// module id = 802
// module chunks = 2